import "./Privacy.css";

const headerStyle = {
  color: "#3A3A3A",
  fontFamily: "Times New Roman, serif",
  fontStyle: "normal",
  fontWeight: "bold",
  textDecoration: "none",
  fontSize: "12pt",
};

const paragraphStyle = {
  color: "#3A3A3A",
  fontFamily: "Times New Roman, serif",
  fontStyle: "normal",
  fontWeight: "normal",
  textDecoration: "none",
  fontSize: "12pt",
  margin: "0pt",
};

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "16pt" }}>
      {/* Top-Level Heading */}
      <h1
        style={{
          textAlign: "center",
          fontSize: "16pt",
          fontWeight: "bold",
          paddingBottom: "12pt",
          ...headerStyle,
        }}
      >
        Privacy Policy
      </h1>

      {/* Introduction */}
      <p
        style={{
          ...paragraphStyle,
          // paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
          lineHeight: "130%",
        }}
      >
        <strong>MentalFit, LLC</strong> and its affiliates (“MentalFit”, “we”,
        “our”, “us”) respect your privacy. This Privacy Notice describes the
        types of information we collect about users (“user”, “you”, “your”) of
        our products and services, including, without limitation, your use of{" "}
        <a
          href="http://www.mentalfitlife.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.mentalfitlife.com
        </a>
        , any other MentalFit websites or mobile applications made available to
        you by MentalFit or other components which hyperlink to this Privacy
        Notice, (the “Service(s)”), information, and with whom we share it. We
        also describe the rights you may have and how you can contact us about
        our privacy practices. By accessing or using the Services, you signify
        that you have read, understood and agree to our collection, storage, use
        and disclosure of your Personal Information as described in this Privacy
        Notice and our <strong>Terms of Use</strong>. For further information on
        how we process your Personal Information, please use the links below to
        jump to the listed section:
      </p>

      {/* <p
        style={{
          ...paragraphStyle,
          paddingTop: "8pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
          lineHeight: "130%",
        }}
      > */}
      {/* By accessing or using the Services, you signify that you have read,
        understood and agree to our collection, storage, use and disclosure of
        your Personal Information as described in this Privacy Notice and our{" "}
        <strong>Terms of Use</strong>. For further information on how we process
        your Personal Information, please use the links below to jump to the
        listed section: */}
      {/* </p> */}

      <ol style={{ paddingLeft: "4pt" }}>
        {/* 1. When this Privacy Notice Applies */}
        <li>
          <h1 style={{ ...headerStyle, textIndent: "-12pt" }}>
            1. When this Privacy Notice Applies
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "3pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            This Privacy Notice applies to your “Personal Information,” which
            includes information that may identify you, and that we collect or
            which is derived from your interactions with our Services. Examples
            of Personal Information may include your name, your address, or an
            online identifier that could identify you (such as an IP address).
            Depending on where you live, Personal Information may have a
            different definition according to the local privacy laws in your
            area. This Privacy Notice applies to all types of Personal
            Information as defined by the local privacy laws that apply to you.
            This Privacy Notice also applies to your use of the Engage a Pro
            feature. However, any personal information you share directly with
            third-party wellness providers via the Engage a Pro feature is
            governed by those providers’ respective privacy practices, not
            MentalFit’s. We encourage you to review their privacy policies prior
            to engaging their services.
          </p>
          <p
            style={{
              ...paragraphStyle,

              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            This Privacy Notice <i>does not</i> apply to:
          </p>
          <ul className="custom-list">
            <li>
              <p style={{ textIndent: "-4pt", lineHeight: "130%" }}>
                Third-party websites or services that may be linked within our
                Service. Any information you provide to those third-party
                websites are controlled by those third parties and are subject
                to their privacy policies. We encourage you to read their
                privacy policies carefully before giving them your information.
              </p>
            </li>
            <li>
              <p
                style={{
                  paddingTop: "11pt",
                  textIndent: "-4pt",
                  lineHeight: "130%",
                }}
              >
                Certain components or offerings that may have their own privacy
                notices that are provided to you, and in such an instance, these
                privacy notices will apply.
              </p>
            </li>
          </ul>
        </li>

        {/* 2. Types of Personal Information We Collect */}
        <li>
          <h1
            style={{
              ...headerStyle,
              paddingTop: "7pt",
              // paddingLeft: "5pt",
              textIndent: "-12pt",
            }}
          >
            2. Types of Personal Information We Collect
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            We collect and generate different types of Personal Information
            depending on how you use or interact with our Services. The
            categories and sources of Personal Information we collect and
            generate about you may include:
          </p>
          <ol style={{}}>
            {[
              "Demographic and Contact Information: Demographic and contact information that you provide to us. For example, we may collect information such as your name, mailing address, e-mail address, and telephone.",
              "Online or Other Account Information: Username or email address and corresponding passwords, security questions, and other information needed to permit access to certain components of our Services which require registration and/or credentials.",
              "Creating an Account and Onboarding: When you create a user account, we collect information that enables you to register and onboard to use our products and Services, such as your name, company, date of birth, contact information (phone number, email address), location, preferred password, and primary language.",
              "Webforms and Requests: Information you submit to us through online or interactive forms available within our Services. For example, you may “contact us,” submit feedback, request additional information about a product or Service, sign up for a mailing or other type of newsletter, or reach out to us regarding a question or concern.",
              "Websites: Information such as your username and password to enter certain sections of our websites or Services, unique identifiers, preference information (such as marketing preferences), browser type, Internet service provider (ISP), referring/exit pages, the files viewed on our site, operating system, date/time stamp, and clickstream data and other pieces of information. This is further described in tracking technologies subsection below.",
              "Mobile Applications: Some of our Services are available either as mobile applications or mobile sites that you can use on your mobile device. If you use a mobile device to access and use our Services, we may additionally collect mobile-specific information including your device ID, device type, hardware type, media access control (“MAC”) address, the version of your mobile operating system, the platform used to access or download the Services, location information and usage information about your device and your use of the Services. Please note that not all of our mobile Services link to this Privacy Notice, so be sure to read the applicable privacy notice before using mobile Services.",
              "Device Information: We may collect device information such as Internet Protocol (“IP”) addresses, log information, error messages, device type, hardware model, operating system, unique device identifiers, and mobile network information. For example, we collect IP addresses from you when you log into the Service as part of our log-in and security features. If you use a mobile device to access and use our Services, we may additionally collect mobile-specific information. We may also associate the information we collect from your different devices, which helps us provide consistent Services across your devices.",
              "Log Information: Usage details of our Services, including the address (or URL) where you came from before visiting us, which pages or features you visit or utilize, which browser you use, search terms you enter, and items you click on. We may also create usage statistics and monitor the traffic from your use or interaction with our Services.",
              "Internet Protocol (IP) Addresses: Internet protocol (IP) addresses are unique identifiers automatically assigned to each computer when logging onto the Internet. We generally collect IP address information from visitors using or interacting with the Services and we log them for system administration purposes. In some cases, as described below in the Tracking Technologies subsection, we may also use IP addresses to serve you ads on third party websites regarding our Services that may be of interest to you based upon your use or interaction with the Services if you have opted-in to certain types of cookies. You can always adjust your Cookie Settings or your individual browser’s settings.",
              "Location Information: Your location information may be collected in a variety of ways depending on how you use or interact with our Services. For example, location information can be derived from your IP address, location information associated with your use of a device, your country or location selection, or other location-based components and content of our Services.",
              "Progress Information: We also may collect information about your progress in using the Service, but only if you choose to provide this information to us. Progress information may be used to customize your Services. This information may include responses to wellness quizzes, surveys or other tasks.",
              "Business Interactions: Information derived from your business-related requests, communications, and dealings we have with you, or the company/organization you work(ed) for or are associated with. This may include your job title, business contact information (phone, email, fax, and address), information about products or Services you expressed an interest in or purchased from us, or that we have purchased from you or your company/organization, and other information needed to verify your ability to conduct business with us.",
              "Social Media: Our Services may link to our pages or accounts on third party social media networks (“social media”) but our Services may use social media plug-ins. If you choose to interact with us on social media, we may collect the information you publish or submit. Note that this information is also governed by the privacy policies of the respective companies offering the social media service.",
              "Forums and Blog: Some Services may link to blogs or forums (“forums”) that may or may not be owned or operated by MentalFit. If you choose to participate in forums, we may collect the information you submit to the forums. Note that such information may also be governed by the privacy policies of the respective companies offering the forums.",
              "Video Recording and Photographs: If you choose to use certain portions of our Services which involve video and/or photography, we will collect this Personal Information from you in order to provide you with the Services you have requested.",
              "Customer Support, Product Research, and Feedback: When you reach out to us such as to obtain support, give us feedback about the Service and our Providers, or participate in optional satisfaction surveys, product research (including user testing), we may also collect information that you choose to share.",
              "Engage a Pro Providers: At your direction, we may facilitate the transmission of your information (e.g., name, contact details, or self-submitted intake forms) to third-party wellness providers available through the Engage a Pro feature. MentalFit does not access or store private session notes or communications between you and any provider. Those providers are solely responsible for the privacy and security of information you choose to share with them.",
            ].map((item, index) => {
              const [title, ...rest] = item.split(": ");
              return (
                <li key={index}>
                  <p
                    style={{
                      paddingTop: index === 0 ? "3pt" : "12pt",
                      // paddingLeft: "5pt",
                      textIndent: "-18pt",
                      lineHeight: "130%",
                    }}
                  >
                    <strong>
                      {index + 1}. {title}:
                    </strong>{" "}
                    {rest.join(": ")}
                  </p>
                </li>
              );
            })}
          </ol>

          <h1
            style={{
              ...headerStyle,
              paddingTop: "7pt",
              paddingLeft: "5pt",
              textIndent: "-18pt",
            }}
          >
            2.1 Third-Party Providers via Engage a Pro
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            The Engage a Pro feature connects users with independent third-party
            wellness providers. Any interaction, exchange of personal
            information, or services rendered between you and such providers
            occurs outside of MentalFit’s control. We do not monitor, store, or
            assume responsibility for communications or data shared between you
            and any provider. Those providers are not employees or contractors
            of MentalFit and are independently responsible for complying with
            applicable privacy and confidentiality laws.
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            We recommend reviewing each provider’s privacy practices and data
            handling procedures before sharing any sensitive information with
            them.
          </p>

          <h1
            style={{
              ...headerStyle,
              paddingTop: "8pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
            }}
          >
            Types of Users
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            Based on the type of user you are, and which components of our
            Services you utilize, we may also collect additional types of
            Personal Information such as:
          </p>
          <ol style={{ paddingLeft: "5pt" }}>
            {[
              "Users of Online Services: How you use and interact with our online Services, such as the date of your last login, the type of content that you viewed or accessed, pages you viewed, features you use, your browser and device type, error reports, and any links you click on to leave or interact with the Service.",
              "Members: To enable us to personalize your experience, provide care options, and design new products and Services, we also collect your answers to our well-being assessment as well as information about your preferred areas of focus.",
              "Customers: Health plan information, payment information, and eligible employees.",
              "Prospective Applicants or Employees: Information related to your prospective employment with us including but not limited to work history, education, the contents of your resume, references. If you later become an employee of MentalFit, you will receive a separate privacy notice which describes how your employment information will be handled.",
            ].map((item, index) => {
              const [title, ...rest] = item.split(": ");
              return (
                <li key={index}>
                  <p
                    style={{
                      paddingTop: index === 0 ? "0pt" : "12pt",
                      paddingLeft: "5pt",
                      textIndent: "-18pt",
                      lineHeight: "130%",
                    }}
                  >
                    <strong>
                      {index + 1}. {title}:
                    </strong>{" "}
                    {rest.join(": ")}
                  </p>
                </li>
              );
            })}
          </ol>

          <h1
            style={{
              ...headerStyle,
              paddingTop: "8pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
            }}
          >
            Personal Information Obtained From Third Parties
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            We may also get Personal Information about you from other third
            parties where permitted by applicable law, and combine that with
            Personal Information you provide us, in order to provide you with
            more personalized Services. For example, we may receive Personal
            Information about you from our customers (who may be your employer)
            to enable us to validate your eligibility to use the Service. This
            information may include your name, work email address, postal code,
            date of birth, gender, race/ethnicity, employee ID number or code
            (if applicable), employment start and end dates, department, title,
            job code (if applicable), office location, performance information,
            health claims data, or survey information about your work
            satisfaction and related topics. We also may receive Personal
            Information from Providers to help us to match you with a different
            Provider or to facilitate your continuity of care.
          </p>

          <h1
            style={{
              ...headerStyle,
              paddingTop: "8pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
            }}
          >
            Cookies and Tracking Technologies
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            Our Services may incorporate tracking technologies to provide you
            with certain functionalities, which collect or generate Personal
            Information about you when you interact with us.
          </p>
          <ol style={{ paddingLeft: "5pt" }}>
            {[
              "Cookies: A cookie is a small file placed on your hard drive by some of our web pages. HTML5 local stored objects may store larger amounts of information on your browser. When you access the Service, either through our mobile applications or website, certain information (including computer and connection information, mobile application use, browser type and version, operating system and platform details, and the time of accessing the Service) is automatically collected. We, or third parties we do business with, may use cookies to help us analyze our web page flow, customize the Service, content and advertising, measure promotional effectiveness, and promote trust and safety. This information will be collected every time you access the Services and it will be used for the purposes outlined in this Privacy Notice.",
              "Tags: Pieces of code, or tags, which gather information about users. For example, tags are used on our websites to better understand online usage patterns and trends. We may also use tags in our emails or newsletters to count how many of those messages are read.",
              "Widgets: Small components embedded within our Services which enable you to use certain functionalities.",
              "Google Analytics: Google Analytics uses cookies to collect data such as time of visit, website pages visited, time spent on each MentalFit website page, IP address, URL, and type of operating system. To learn more about how Google Analytics collects and processes Personal Information, please visit <a href='https://www.google.com/policies/privacy/partners' target='_blank' rel='noopener noreferrer'>www.google.com/policies/privacy/partners</a>. To opt out of having your activity available to Google Analytics, you can download the <a href='https://tools.google.com/dlpage/gaoptout' target='_blank' rel='noopener noreferrer'>Google Analytics opt-out browser add-on</a>.",
              "Web Beacons: Web beacons are electronic images placed in the code of a webpage, application or email that allow us to monitor things such as user activity and site traffic. Web beacons may be used to track the traffic patterns of users from one page to another in order to maximize web traffic flow.",
              "Advertising: We do not target any advertisements toward individual consumers or members of our platform. Nothing you do on the MentalFit app or web platform will be used by us to target any advertisements towards you as an individual consumer anywhere else on the internet. We may engage third party service providers who utilize tracking technologies on our corporate website (www.mentalfitlife.com) to serve advertisements that may be of interest to potential employer-buyers of our Services. Some of these advertisements may be personalized, meaning that the advertisements are intended to be relevant to potential Organizational-buyers based on what we, or the third party service providers, know about them, such as employment at or agency for a company that might be interested in offering MentalFit as a benefit to its employees.",
            ].map((item, index) => {
              const [title, ...rest] = item.split(": ");
              return (
                <li key={index}>
                  <p
                    style={{
                      paddingTop: index === 0 ? "3pt" : "12pt",
                      paddingLeft: "5pt",
                      textIndent: "-18pt",
                      lineHeight: "130%",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: `<strong>${
                        index + 1
                      }. ${title}:</strong> ${rest.join(": ")}`,
                    }}
                  />
                </li>
              );
            })}
          </ol>

          <h1
            style={{
              ...headerStyle,
              paddingTop: "8pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
            }}
          >
            Your Settings and Preferences
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            You can reduce the information cookies and other technologies
            collected from your device by changing your browser settings to
            notify you when a cookie is being set or updated, or to block
            cookies altogether. Some browsers also allow you to control local
            stored objects through your browser settings. More information about
            how to do this may be found at{" "}
            <a
              href="http://www.allaboutcookies.org/manage-cookies"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.allaboutcookies.org/manage-cookies
            </a>{" "}
            or in the “Help” section of your browser. If you choose to block
            cookies, your use of the Service may be impacted.
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            If you would like more information about this and to know your
            choices about not having this information used by these companies,
            please visit: the Digital Advertising Alliance’s website,{" "}
            <a
              href="https://www.aboutads.info/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.aboutads.info/
            </a>
            , or the Network Advertising Initiative’s{" "}
            <a
              href="http://networkadvertising.org/consumer/opt_out.asp"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://networkadvertising.org/consumer/opt_out.asp
            </a>
            .
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            <strong>Global Privacy Control (GPC)</strong> is a browser setting
            that notifies websites of a consumer’s privacy preferences. Our
            website (www.mentalfitlife.com) detects the GPC signal on supported
            browsers and plugins. We do not use any advertising, analytics, or
            performance tracking technologies unless you agree when you first
            enter our website (www.mentalfitlife.com) regardless of whether you
            have enabled the GPC signal.
          </p>
        </li>

        {/* 3. How We Use Personal Information */}
        <li>
          <h1
            style={{
              ...headerStyle,
              paddingTop: "7pt",
              // paddingLeft: "5pt",
              textIndent: "-12pt",
            }}
          >
            3. How We Use Personal Information
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            Depending on what Services you use and how you interact with us, we
            may use your Personal Information in the following ways. If you live
            in certain jurisdictions (including but not limited to the European
            Union), we may not process your Personal Information unless you
            first provide us with your consent to do so.
          </p>
          <ol style={{ paddingLeft: "5pt" }}>
            {[
              "To administer the Services;",
              "To manage business transactions;",
              "To respond to your inquiries and provide information about the Services;",
              "To send you marketing information;",
              "To send you advertisements you may be interested in;",
              "To improve the Services and user experience;",
              "If we are involved in a merger, acquisition, or sale of our assets (or a portion thereof), it may impact how we process your Personal Information. In such an instance, we will comply with all applicable laws and treat your Personal Information accordingly;",
              "To register and onboard you for the use of the Service and to further tailor our products and Services for your use;",
              "To provide the Service, including to communicate with you regarding any scheduled or available Services or to connect you to a Provider;",
              "To maintain, manage and secure your access to the Services through our web and mobile apps;",
              "To maintain records relating to your account;",
              "To manage our relationship and communicate with you and our customers about new features and Services that we may offer;",
              "To respond to inquiries and resolve disputes;",
              "To conduct research such as case studies and academic research;",
              "To carry out analytics, quality control, security processes and similar activities, in order to identify and develop potential improvements to the Services;",
              "To aggregate claim information and analyze outcomes for the Services;",
              "To measure your satisfaction with MentalFit Service through surveys, feedback and ratings;",
              "To process payments from you in certain circumstances;",
              "To prevent, detect, and prosecute illegal or fraudulent activity on the Service; and",
              "Other uses required to do so by law, for example in order to maintain accounting records, compliance with applicable retention obligations, for purposes of reporting obligations, to respond to lawful requests by public authorities, to investigate potential breaches and to protect our rights, property, safety and those of our users.",
              "When permitted by law, we may also enhance or combine information about you, including your Personal Information, with information about you that we obtain from third parties for the same purposes described in this Privacy Notice.",
            ].map((item, index) => (
              <li key={index}>
                <p
                  style={{
                    // paddingTop: index === 0 ? "3pt" : "12pt",
                    // paddingLeft: "5pt",
                    textIndent: "-18pt",
                    lineHeight: "130%",
                  }}
                >
                  {index + 1}. {item}
                </p>
              </li>
            ))}
          </ol>
        </li>

        {/* 4. How We Share Personal Information */}
        <li>
          <h1
            style={{
              ...headerStyle,
              paddingTop: "3pt",
              // paddingLeft: "17pt",
              textIndent: "-12pt",
            }}
          >
            4. How We Share Personal Information{" "}
          </h1>
          <p
            style={{
              ...paragraphStyle,
              // paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            We may share your Personal Information to the following parties, and
            for the following reasons, in accordance with applicable law:
          </p>
          <ol style={{ paddingLeft: "5pt" }}>
            {[
              "MentalFit Affiliates: To our related MentalFit professional entity affiliates, in order to provide you with the Services.",
              "Service Providers: To third party companies and individuals that we hire to perform services on our behalf, including to help us administer and provide the Services to you. These third parties are required to treat your Personal Information in accordance with appropriate contractual and legal privacy and security requirements.",
              "Links to/From Third-Party Website: As a resource to our users, we may provide links to/from other unaffiliated websites or services within our Services. If you choose to visit such third-party websites or services, please note that any information you submit to them is subject to the privacy notice of the third-party website or service and not subject to this Privacy Notice.",
              "Customers: Customers include, but are not limited to employers, educational institutions, and non-profits. We do not share any Personal Information with Customers unless necessary to prevent imminent harm (e.g., crisis management) or as required by law. We only share anonymized and aggregated information with Customers. MentalFit provides several administrator controls to allow Customers to manage the platform. For example, to create encouragement groups, upload and control rewards, and manage users. If you are accessing the service through a Customer (such as single sign-on), the Customer may collect information about your login activity, including whether and when you access MentalFit Services. MentalFit does not control the information collection practices of Customers or other benefit providers, and you should consult their internal policies and procedures for more information about their information collection practices.",
              "No Sale of Personal Information: We do not sell, disclose, and/or share your Personal Information to other businesses or third parties for monetary or valuable consideration.",
            ].map((item, index) => {
              const [title, ...rest] = item.split(": ");
              return (
                <li key={index}>
                  <p
                    style={{
                      paddingTop: index === 0 ? "3pt" : "12pt",
                      // paddingLeft: "5pt",
                      textIndent: "-18pt",
                      lineHeight: "130%",
                    }}
                  >
                    <strong>
                      {index + 1}. {title}:
                    </strong>{" "}
                    {rest.join(": ")}
                  </p>
                </li>
              );
            })}
          </ol>

          <h1
            style={{
              ...headerStyle,
              paddingTop: "3pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
            }}
          >
            Communications and Email Preferences
          </h1>
          <p
            style={{
              ...paragraphStyle,
              // paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            When you create a MentalFit account, we will send you certain email
            communications that are necessary to provide and support our
            services. These transactional or service-related emails may include,
            without limitation, welcome messages, appointment confirmations,
            reminders, password resets, account notifications, and other
            messages directly related to your use of MentalFit.
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            We may also send occasional promotional or informational emails
            about new features, wellness content, events, or services that we
            believe may be relevant to you. You can opt out of receiving these
            non-essential promotional emails at any time by following the
            unsubscribe instructions in the email or by adjusting your
            preferences in your account settings.
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            Please note that transactional or service-related emails are an
            essential part of your MentalFit experience and you cannot opt out
            of receiving them without deactivating your account. We will not
            include protected health information (PHI) in any email
            communications.
          </p>
        </li>

        {/* 5. International Data Transfers */}
        <li>
          <h1
            style={{
              ...headerStyle,
              paddingTop: "3pt",
              // paddingLeft: "17pt",
              textIndent: "-12pt",
            }}
          >
            5. International Data Transfers{" "}
          </h1>
          <p
            style={{
              ...paragraphStyle,
              // paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            MentalFit is a U.S. based company, and therefore we may transfer
            your Personal Information outside of the country in which you reside
            in order to provide you with the Service. We may also engage global
            service providers to assist us in providing you with the Service.
            Those countries may not have the same data protection laws as your
            resident country. If we transfer your Personal Information, we will
            comply with applicable legal requirements regarding providing
            appropriate safeguards for the transfer of Personal Information,
            (e.g., standard contractual clauses, data transfer agreements) to
            protect your Personal Information in accordance with this Privacy
            Notice.
          </p>
        </li>

        {/* 6. How We Protect Personal Information */}
        <li>
          <h1
            style={{
              ...headerStyle,
              paddingTop: "3pt",
              // paddingLeft: "17pt",
              textIndent: "-12pt",
            }}
          >
            6. How We Protect Personal Information{" "}
          </h1>
          <p
            style={{
              ...paragraphStyle,
              // paddingTop: "1pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            MentalFit maintains technical, physical and organizational
            safeguards to ensure an appropriate level of security and
            confidentiality for your Personal Information, in accordance with
            our policies and applicable laws. However, no service or online
            platform is 100% secure. In addition, any unencrypted communications
            you send to us cannot be protected completely against unauthorized
            access, nor is MentalFit responsible for unauthorized access to your
            Personal Information when sent to your personal email address, upon
            your request. You are responsible for maintaining the security of
            your devices and online accounts, including by not sharing your
            password or credentials for the Service with others.
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            Within our organization, only those personnel for whom access is
            necessary due to their role, task or function will be granted access
            topele your Personal Information.
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            <strong>Do Not Track:</strong> Your browser settings may allow you
            to automatically transmit a Do Not Track signal to websites and
            other online Services you visit. We do not alter our practices when
            we receive a Do Not Track signal from a visitor’s browser. To find
            out more about Do Not Track, please visit{" "}
            <a
              href="https://www.allaboutdnt.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.allaboutdnt.com
            </a>
            .
          </p>
        </li>

        {/* 7. Retention of Personal Information */}
        <li>
          <h1
            style={{
              ...headerStyle,
              paddingTop: "7pt",
              // paddingLeft: "17pt",
              textIndent: "-12pt",
            }}
          >
            7. Retention of Personal Information{" "}
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            Information that we collect will be retained in a personally
            identifiable form for as long as necessary for the purposes
            described above, after which it will be deleted or maintained in a
            non-personally identifiable form. We may retain information in order
            to comply with our legal obligations (such as tax, accounting or
            health privacy purposes). If you have any questions about applicable
            retention periods, please contact us at{" "}
            <a href="mailto:info@mentalfitlife.com">info@mentalfitlife.com</a>.
          </p>
        </li>

        {/* 8. Minors */}
        <li>
          <h1
            style={{
              ...headerStyle,
              paddingTop: "7pt",
              // paddingLeft: "17pt",
              textIndent: "-12pt",
            }}
          >
            8. Minors
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            Online components of our Services are not directed to children under
            the age of thirteen (13), and we do not knowingly collect Personal
            Information via online Services from children under the age of 18.
            If you think that we have collected Personal Information via an
            online Service from a child under the age of 18, please contact us.
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            The Service is not intended to be accessed by minors under the age
            of eighteen (18). If we discover that an individual under 18 has
            provided us with Personal Information, we will delete the Personal
            Information to the extent required by the Children’s Online Privacy
            Protection Act.
          </p>
        </li>

        {/* 9. Legal Basis for Processing */}
        <li>
          <h1
            style={{
              ...headerStyle,
              paddingTop: "3pt",
              // paddingLeft: "17pt",
              textIndent: "-12pt",
            }}
          >
            9. Legal Basis for Processing
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            MentalFit will only use or process your Personal Information if the
            use or processing is permitted by applicable privacy laws in your
            jurisdiction. This is sometimes referred to as having a “legal
            basis” to use your Personal Information. The legal basis we may rely
            on to process your Personal Information may include:
          </p>
          <ol style={{}}>
            {[
              "Performance of a Contract: For example, to carry out our contractual obligations with you pursuant to a contract to supply goods or services.",
              "Legal Obligations: For example, some countries have transparency requirements regarding interactions with healthcare professionals, or requirements to provide information to authorities in case of adverse events or medical incidents related to the use of our Services.",
              "Vital Interests: For example, when processing your Personal Information is in your vital interest or required to protect your life.",
              "Consent: For example, if you opt-in to receive marketing communications from us or expressly provide your consent for us to process your Personal Information. In the event you provide your consent, you may also withdraw your consent when permitted by applicable law, if you contact us.",
              "Legitimate Interests: This may include, for example, managing, operating, maintaining, and securing our websites, network systems, and other assets; and providing you with features and functionalities in the Services.",
            ].map((item, index) => {
              const [title, ...rest] = item.split(": ");
              return (
                <li key={index}>
                  <p
                    style={{
                      paddingTop: index === 0 ? "3pt" : "12pt",
                      // paddingLeft: "5pt",
                      textIndent: "-18pt",
                      lineHeight: "130%",
                    }}
                  >
                    <strong>
                      {index + 1}. {title}:
                    </strong>{" "}
                    {rest.join(": ")}
                  </p>
                </li>
              );
            })}
          </ol>
        </li>

        {/* 10. Data Subject Rights */}
        <li>
          <h1
            style={{
              ...headerStyle,
              paddingTop: "5pt",
              // paddingLeft: "17pt",
              textIndent: "-12pt",
            }}
          >
            10. Data Subject Rights
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "1pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            You have control over your Personal Information as described in more
            detail below. For example, you may request access to or deletion of
            your Personal Information by contacting us. We will honor your
            request regardless of where you live or are physically located
            unless a legal requirement prevents us from doing so or a legal
            exception applies. To make a request related to your Personal
            Information, contact us at{" "}
            <a href="mailto:getstarted@mentalfitlife.com">
              getstarted@mentalfitlife.com
            </a>
            . (If you are a former employee or worker of MentalFit and you would
            like to exercise your privacy rights or learn more about your
            privacy rights as a former employee or worker, contact us at{" "}
            <a href="mailto:getstarted@mentalfitlife.com">
              getstarted@mentalfitlife.com
            </a>
            )
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "3pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            With respect to your Personal Information, you may:
          </p>
          <ol style={{}}>
            {[
              "Withdraw consent: If we use or share your Personal Information based on your consent, you may withdraw your consent at any time.",
              "Access: You may request access to or copies of your Personal Information. You may also request what types of Personal Information we have, the purposes for which we process it, and who has received access to your Personal Information.",
              "Correction and Deletion: You may request that we correct your Personal Information if you think it is inaccurate or incomplete. You can also request that we erase or delete your Personal Information. Please note, if you are a MentalFit member, you can immediately request deletion of your Personal Information/account within the MentalFit mobile app by clicking on “Delete Account” in the account settings and following the instructions to complete your request. Once your Personal Information/account is deleted, you will no longer be able to access your account.",
              "Restrict Processing: You may request that we restrict the processing of certain Personal Information.",
              "Data Portability: You may request that we provide you with your Personal Information that we obtained from you, and you can ask us to provide it to another entity.",
              "Object: You may have the right to object to our processing of your Personal Information for certain purposes.",
              "Lodge a Complaint: If you believe we are using, disclosing, or otherwise processing your Personal Information in a way that is not in accordance with applicable law, you can lodge a complaint with the relevant data protection authority in your country.",
            ].map((item, index) => {
              const [title, ...rest] = item.split(": ");
              return (
                <li key={index}>
                  <p
                    style={{
                      paddingTop: index === 0 ? "3pt" : "12pt",
                      // paddingLeft: "5pt",
                      textIndent: "-18pt",
                      lineHeight: "130%",
                    }}
                  >
                    <strong>
                      {index + 1}. {title}:
                    </strong>{" "}
                    {rest.join(": ")}
                  </p>
                </li>
              );
            })}
          </ol>
        </li>

        {/* 11. Updates To Our Privacy Notice */}
        <li>
          <h1
            style={{
              ...headerStyle,
              paddingTop: "7pt",
              // paddingLeft: "17pt",
              textIndent: "-12pt",
            }}
          >
            11. Updates To Our Privacy Notice
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            This Privacy Notice may be updated periodically to reflect changes
            in our information practices. If we make any significant changes to
            our Privacy Notice, we will provide you notice via the Services, or
            by other communication channels such as posting a notice on our
            website or sending you an email. In the event that we use your
            Personal Information for other purposes not specified in this
            Privacy Notice, we will notify you. You can see when this Privacy
            Notice was last updated by checking the “last updated” date
            displayed at the top of this Privacy Notice. Please review any
            changes carefully. We encourage you to periodically review this
            Privacy Notice for the latest information on our privacy practices.
          </p>
        </li>

        {/* 12. How to Contact Us */}
        <li>
          <h1
            style={{
              ...headerStyle,
              paddingTop: "3pt",
              // paddingLeft: "17pt",
              textIndent: "-12pt",
            }}
          >
            12. How to Contact Us
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "1pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            If you have questions about this Privacy Notice, our information
            practices, or how MentalFit handles your information, or if you
            would like to exercise your rights, please reach out by emailing or
            writing to us at:
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            <strong>MentalFit, LLC</strong>
            <br />
            4280 E Iowa Ave #702, Denver, CO 80223
            <br />
            Email:{" "}
            <a href="mailto:info@mentalfitlife.com">info@mentalfitlife.com</a>
          </p>
        </li>

        {/* 13. Notice for California Consumers */}
        <li>
          <h1
            style={{
              ...headerStyle,
              paddingTop: "7pt",
              // paddingLeft: "17pt",
              textIndent: "-12pt",
            }}
          >
            13. Notice for California Consumers
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            To the extent you are a California resident and your “Personal
            Information” is subject to the CCPA, this Section applies to our
            collection and use of Personal Information, as required by the
            California Consumer Privacy Act of 2018 and its implementing
            regulations (the “CCPA”). When we use the term “Personal
            Information” in the context of the CCPA, we mean information that
            identifies, relates to, describes, is capable of being associated
            with, or could reasonably be linked, directly or indirectly, with a
            particular California consumer or household.
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            Throughout this Privacy Notice, we discuss in detail the specific
            Types of Personal Information We Collect from and about users. Under
            the CCPA, we are also required to provide you with the “categories”
            of Personal Information we collected and disclosed within the past
            twelve (12) months for a business purpose:
          </p>
          <ol style={{}}>
            {[
              "Identifiers: A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email address, account name, Social Security number, driver's license number, passport number, or other similar identifiers.",
              "Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e)): A name, signature, Social Security number, physical characteristics or description, address, telephone number, passport number, driver's license or state identification card number, insurance policy number, education, employment, employment history, bank account number, credit card number, debit card number, or any other financial information, medical information, or health insurance information. Some personal information included in this category may overlap with other categories.",
              "Protected classification characteristics under California or federal law: Age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed, marital status, medical condition, physical or mental disability, sex (including gender, gender identity, gender expression, pregnancy or childbirth and related medical conditions), sexual orientation, veteran or military status, genetic information (including familial genetic information).",
              "Commercial information: Records of personal property, products or services purchased, obtained, or considered, or other purchasing or consuming histories or tendencies.",
              "Biometric information: Genetic, physiological, behavioral, and biological characteristics, or activity patterns used to extract a template or other identifier or identifying information, such as, fingerprints, faceprints, and voiceprints, iris or retina scans, keystroke, gait, or other physical patterns, and sleep, health, or exercise data.",
              "Internet or other similar network activity: Browsing history, search history, information on a consumer's interaction with a website, application, or advertisement.",
              "Geolocation data: Physical location or movements.",
              "Sensory data: Audio, electronic, visual, thermal, olfactory, or similar information.",
              "Professional or employment-related information: Current or past job history or performance evaluations.",
              "Inferences drawn from other personal information: Profile reflecting a person's preferences, characteristics, psychological trends, predispositions, behavior, attitudes, intelligence, abilities, and aptitudes.",
            ].map((item, index) => {
              const [title, ...rest] = item.split(": ");
              return (
                <li key={index}>
                  <p
                    style={{
                      paddingTop: index === 0 ? "3pt" : "12pt",
                      // paddingLeft: "5pt",
                      textIndent: "-18pt",
                      lineHeight: "130%",
                    }}
                  >
                    <strong>
                      {index + 1}. {title}:
                    </strong>{" "}
                    {rest.join(": ")}
                  </p>
                </li>
              );
            })}
          </ol>

          <p
            style={{
              ...paragraphStyle,
              // paddingTop: "2pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            We obtain the above listed categories of Personal Information from
            the following sources (in addition to directly from users), as
            identified in this Privacy Notice:
          </p>
          <ul className="custom-list">
            <li style={{ listStyle: "disc", paddingLeft: "5pt" }}>
              Types of users
            </li>
            <li style={{ listStyle: "disc", paddingLeft: "5pt" }}>
              Personal Information obtained from third parties.
            </li>
          </ul>

          <p
            style={{
              ...paragraphStyle,
              paddingTop: "8pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            We disclose the above listed categories of Personal Information to
            the following categories of third parties, as described in the{" "}
            <em>How we Use your information</em> section.
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            We collect and disclose the above listed categories of Personal
            Information for the business purposes, as described in the{" "}
            <em>How we use your personal information</em> section.
          </p>

          <h1
            style={{
              ...headerStyle,
              // paddingTop: "8pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
            }}
          >
            Sale of Personal Information
          </h1>
          <p
            style={{
              ...paragraphStyle,
              // paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            In the last twelve (12) months, we have not sold any Personal
            Information of California Consumers. The CCPA defines “sale” as:
            selling, renting, releasing, disclosing, disseminating, making
            available, transferring, or otherwise communicating orally, in
            writing, or by electronic or other means, a consumer’s Personal
            Information to another business or third party for monetary or
            valuable consideration.
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            If we ever do sell your Personal Information, we will notify you,
            and if you submit to us a verifiable consumer request using the
            contact information in section 12 above, we will disclose to you a
            list containing the categories of Personal Information that we sold
            in accordance with the CCPA’s requirements.
          </p>

          <h1
            style={{
              ...headerStyle,
              // paddingTop: "8pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
            }}
          >
            California Privacy Rights
          </h1>
          <p
            style={{
              ...paragraphStyle,
              // paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            California residents may exercise certain CCPA privacy rights with
            respect to their Personal Information:
          </p>
          <ul className="custom-list">
            {[
              "Notice: The right to be notified of what categories of Personal Information will be collected at or before the point of collection and the purpose for which they will be used and shared.",
              "Right to Know/Access: You have the right to request that we disclose to you what Personal Information we collect, use, disclose, and sell about you, including: The categories of Personal Information we have collected about you in the preceding 12 months; The categories of sources from which the Personal Information is collected; The business or commercial purpose for collecting or selling the Personal Information; The categories of Personal information, if any, that we disclosed for a business purpose or sold to third parties in the preceding 12 months; and The categories of third parties to whom the information was disclosed or sold.",
              "Data Portability: The right to receive the Personal Information you have previously provided to us.",
              "Right to Delete: You have the right to request that we delete the Personal Information we collect about you.",
              "To Opt-Out: You have the right to opt-out of the sale of your Personal Information to third parties. Currently, we do not sell your Personal Information. If you have any questions, please reach out to us by using the contact information below.",
              "Right to Non-Discrimination: You have the right to not receive discriminatory treatment by us if you exercise any of the rights conferred to you by the CCPA.",
            ].map((item, index) => (
              <li
                key={index}
                style={{
                  paddingTop: index === 0 ? "3pt" : "8pt",
                  listStyle: "disc",
                  // paddingLeft: "5pt",
                }}
              >
                <strong>{item.split(":")[0]}:</strong>{" "}
                {item.split(":").slice(1).join(":")}
              </li>
            ))}
          </ul>

          <h1
            style={{
              ...headerStyle,
              // paddingTop: "8pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
            }}
          >
            How to Exercise Your California Rights
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            If you are a California resident and would like to exercise any of
            your rights listed above, please contact us. You may also designate
            an authorized agent to make a request to exercise your rights on
            your behalf. In order to do so, you must submit the form linked
            above or contact us.
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            While we take measures to ensure that those responsible for
            receiving and responding to your request are informed of your rights
            and how to help you exercise those rights, when contacting us to
            exercise your rights, we ask you to please adhere to the following
            guidelines:
          </p>
          <ul className="custom-list">
            {[
              "Tell Us Which Right You Are Exercising: Specify which right you want to exercise and the Personal Information to which your request relates (if it does not relate to you). If you are acting as an authorized agent on behalf of a California resident, please clearly indicate this fact and indicate your authority to act on their behalf.",
              "Help Us Verify Your Identity: Contact us and provide us with enough information to verify your identity. Please note that if we cannot initially verify your identity, we may request additional information to complete the verification process. Any Personal Information you disclose to us for purposes of verifying your identity will solely be used for the purpose of verification.",
              "Direct Our Response Delivery: Inform us of the delivery mechanism with which you prefer to receive our response. You may specify, for example, email, mail, or through your account (if you have one with us).",
            ].map((item, index) => (
              <li
                key={index}
                style={{
                  paddingTop: "8pt",
                  listStyle: "disc",
                  // paddingLeft: "5pt",
                }}
              >
                <strong>{item.split(":")[0]}:</strong>{" "}
                {item.split(":").slice(1).join(":")}
              </li>
            ))}
          </ul>

          <p
            style={{
              ...paragraphStyle,
              // paddingTop: "8pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            Please note that you do not need to create an account with us in
            order to make a request to exercise your rights hereunder.
          </p>

          <h1
            style={{
              ...headerStyle,
              // paddingTop: "8pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
            }}
          >
            How We Respond to Your Requests
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            We will work to respond to your Valid Request within 45 days of
            receipt. We will not charge you a fee for making a Valid Request
            unless your Valid Request(s) is excessive, repetitive, or manifestly
            unfounded. If we determine that your Valid Request warrants a fee,
            we will notify you of the fee and explain that decision before
            completing your request.
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            You may submit a Valid Request using the following methods:
          </p>
          <ul style={{ paddingTop: "5pt" }}>
            <li style={{ listStyle: "disc" }}>
              Emailing us at:{" "}
              <a href="mailto:info@mentalfitlife.com">info@mentalfitlife.com</a>
            </li>
          </ul>

          <h1
            style={{
              ...headerStyle,
              // paddingTop: "8pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
            }}
          >
            We Will Not Discriminate Against You for Exercising Your Rights
            Under the CCPA
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            We will not discriminate against you for exercising your rights
            under the CCPA. We will not deny you our goods or services, charge
            you different prices or rates, or provide you a lower quality of
            goods and services if you exercise your rights under the CCPA.
            However, we may offer different tiers of our Services as allowed by
            applicable data privacy laws (including the CCPA) with varying
            prices, rates, or levels of quality of the goods or services you
            receive related to the value of Personal Data that we receive from
            you.
          </p>

          <h1
            style={{
              ...headerStyle,
              // paddingTop: "8pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
            }}
          >
            Contacting the California Attorney General
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "4pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            The CCPA gives California Consumers the right to lodge a complaint
            with the California Attorney General’s office. The Attorney
            General’s office may be contacted at{" "}
            <a
              href="https://oag.ca.gov/contact/consumer-complaint-against-business-or-company"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://oag.ca.gov/contact/consumer-complaint-against-business-or-company
            </a>{" "}
            or by telephone at: (916) 210-6276.
          </p>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "5pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            We encourage you to reach out to us first, however, so that we may
            help resolve any complaints you may have.
          </p>
        </li>

        {/* 14. Business Transfers */}
        <li>
          <h1
            style={{
              ...headerStyle,
              paddingTop: "3pt",
              // paddingLeft: "17pt",
              textIndent: "-12pt",
            }}
          >
            14. Business Transfers
          </h1>
          <p
            style={{
              ...paragraphStyle,
              paddingTop: "1pt",
              // paddingLeft: "5pt",
              textIndent: "0pt",
              lineHeight: "130%",
            }}
          >
            If we are involved in a merger, acquisition, corporate
            reorganization, or sale of assets, your information may be
            transferred as part of that transaction. We will take reasonable
            steps to ensure that your personal information is treated in a
            manner consistent with this Privacy Policy and applicable law, and
            we will provide notice to you before your personal information is
            transferred and becomes subject to a different privacy policy.
          </p>
        </li>
      </ol>
    </div>
  );
};

export default PrivacyPolicy;
